import * as React from "react";
import { Modal, Button } from "antd";
import { TTranslate } from "../../../../service/locale/TranslationService";

export interface State {}

export interface Props {
  translate: TTranslate;
  title?: string;
  visible: boolean;
  onCancel: any;
  onDelete: any;
  message?: string;
  rowData: any;
}

export default class DeleteModal extends React.Component<Props, State> {
  render() {
    const { translate, title, visible, onCancel, onDelete, message, rowData } =
      this.props;

    return (
      <div>
        <Modal
          title={title}
          visible={visible}
          onCancel={onCancel}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={onCancel}>
              {translate("modal_functions.delete_modal.cancel")}
            </Button>,
            <Button
              key="submit"
              type="danger"
              onClick={(e) => {
                onDelete(rowData);
                onCancel();
              }}
            >
              {translate("modal_functions.delete_modal.delete")}
            </Button>
          ]}
        >
          <span>{message}</span>
        </Modal>
      </div>
    );
  }
}
